import React, {useState} from 'react';
import IconComponent from '../icons';
import styles from './text-accordion.module.scss';
import H3 from "../Headings/H3"

const Accordion = ({ accordion, index, newLabelText })=> {
  const {accordionTitle, accordionContent, isNewLabel, opsDateStr } = accordion;
  const [toggle, setToggle] = useState(() => {
    const url = window.location.href;
    return url.includes('service-updates-alerts') && index === 0;
  });

  const renderNewLabelInfo =()=>{
    return <div className='gap-2 h-[21px] flex items-center mb-2 text-ek-grey-500 text-sm leading-[21px]'>
      {isNewLabel && <span className='bg-ek-red rounded px-1 text-white text-xs leading-[18px]'>{newLabelText}</span>}{opsDateStr}
    </div>
  }

  const renderAccordion =()=>{
      return <>
          <div onClick={()=>{setToggle(!toggle)}} className={`px-4 py-2.5 bg-white border-b border-ek-grey-200 cursor-pointer flex items-center justify-between relative`}>
            <div>
            {opsDateStr && renderNewLabelInfo()}
            <H3 className={`pr-4 text-sm lg:text-lg text-black break-words overflow-hidden !font-normal`}>
              <button type="button" aria-expanded={toggle} aria-controls={`accordion-panel-${index}`} id={`accordion-title-${index}`} className={`text-left ${toggle && 'font-bold'}`}>
                {toggle && <span className='w-[5px] h-full bg-ek-red absolute left-0 top-0'></span>}
                {accordionTitle}
                <span className='h-full items-center flex absolute right-4 top-0'><IconComponent icon='chevron-slim' className={`chevron-slim scale-125 relative right-[3px] ${toggle ? '-rotate-90' : 'rotate-90'}`} /></span>
              </button>
            </H3>
            </div>
          </div>
          <div id={`accordion-panel-${index}`} aria-labelledby={`accordion-title-${index}`}  dangerouslySetInnerHTML={{ __html: accordionContent}} className={`px-4 py-[11px] lg:py-5 bg-white text-sm lg:text-base text-black ${styles.content} ${toggle ? "" : "hidden"}`}></div>
          </>
  }

  return (
    <>
      {renderAccordion()}
    </>
  )
}

export default Accordion;